module.exports = __webpack_public_path__ + "static/media/consultantImageTwo.2a9bafcf.png";